import React from "react";
import PedirAjuda from "../components/forms/PedirAjuda";
import useAxios from "../helpers/useAxios";

const Ajuda = () => {
  const { fetch } = useAxios("", "", {}, true);

  const onSubmitPedido = dataForm => {
    fetch("POST", "/User/create-support", {
      Nif: dataForm.nif, 
      Name: dataForm.nome, 
      Email: dataForm.email,
      Subject: dataForm.assunto,
      Description: dataForm.comentario,
      Type: 1,
    });
  }

 return (
  <div className="container">
    <div className="row justify-content-md-center">
      <div className="col-md-8 bg-white my-5 rounded-4 p-5 pt-3">
        <h2 className="mt-4">Esclareça dúvidas</h2>
        <PedirAjuda onSubmitHandler={onSubmitPedido} />
      </div>
    </div>
  </div>
 );
};

export default Ajuda;
